import { render } from "./IframeRemoteFooter.vue?vue&type=template&id=366ebce6&scoped=true"
import script from "./IframeRemoteFooter.vue?vue&type=script&lang=js"
export * from "./IframeRemoteFooter.vue?vue&type=script&lang=js"

import "./IframeRemoteFooter.vue?vue&type=style&index=0&id=366ebce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366ebce6"]])

export default __exports__